import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";

import "./BlueNavTabs.css";

export default function BlueNavTabs(): JSX.Element {
    const { t } = useTranslation("landing");

    const location = useLocation();
    const isTen = window.localStorage.getItem("o_type") === "ten";

    const tabs = [
        {
            link: "/amp/property-assessment",
            title: "landing.haw"
        },
        {
            link: "/amp/property",
            title: "landing.vmpd"
        },
        {
            link: "/amp/nbhd",
            title: "landing.nbhd"
        },
        (!isTen ? {
            link: "/amp/rfr",
            title: "landing.rfr"
        } : null)
,
    ]

    return (
        <div className="blue-nav-tabs">
            {tabs.map((value, index) => {
                if(value !== null) {
                    const className = value.link === location.pathname ? "active" : "";
                    return (
                        <div key={index} className={"blue-nav-tab " + className}>
                            <Link to={value.link}>{t(value.title) as string}</Link>
                        </div>
                    )
                } else {
                    return null; 
                }
            })}
        </div>
    );
}